import { BaseError, JsonError } from "~/errors";
import { err, ok, type Result } from "neverthrow";

export function safeJsonStringify(
  data: object | [],
): Result<string, BaseError> {
  try {
    return ok(JSON.stringify(data));
  } catch (error: unknown) {
    if (!(error instanceof Error)) {
      return err(new JsonError());
    }
    return err(new JsonError(error.message));
  }
}
